module.exports = __webpack_public_path__ + "assets/1-customer-success-manager-job-information.28efc30f.png";